/**
 * Response Strategy Adapter
 * Transforms response strategy data between API and application layer
 */

import { BaseAdapter } from './base.adapter';
import type {
	ResponseStrategy,
	CreateResponseStrategyDto,
	UpdateResponseStrategyDto,
	ResponseStrategyResponseDto,
	ResponseStrategiesListResponseDto
} from '@/types';

export class ResponseStrategyAdapter extends BaseAdapter {
	static fromApi(dto: ResponseStrategyResponseDto): ResponseStrategy {
		return {
			id: dto.id ?? dto._id ?? '',
			accountId: dto.accountId,
			name: dto.name,
			intents: dto.intents ?? [],
			strategy: dto.strategy,
			merchantAsk: dto.merchantAsk,
			version: dto.version,
			isDraft: dto.isDraft,
			isActive: dto.isActive,
			generatedBy: dto.generatedBy,
			createdAt: dto.createdAt,
			updatedAt: dto.updatedAt
		};
	}

	static fromApiList(dtos: ResponseStrategyResponseDto[]): ResponseStrategy[] {
		return dtos.map((dto) => this.fromApi(dto));
	}

	static fromListApi(dto: ResponseStrategiesListResponseDto): { strategies: ResponseStrategy[]; count: number } {
		return {
			strategies: this.fromApiList(dto.strategies ?? []),
			count: dto.count ?? 0
		};
	}

	static toCreateRequest(data: CreateResponseStrategyDto): CreateResponseStrategyDto {
		const payload: CreateResponseStrategyDto = {
			name: data.name.trim(),
			intents: data.intents,
			strategy: data.strategy,
			merchantAsk: data.merchantAsk.trim(),
			isDraft: data.isDraft,
			isActive: data.isActive
		};
		return this.sanitizePayload(payload);
	}

	static toUpdateRequest(data: UpdateResponseStrategyDto): UpdateResponseStrategyDto {
		const payload: UpdateResponseStrategyDto = {
			name: data.name?.trim(),
			intents: data.intents,
			strategy: data.strategy,
			merchantAsk: data.merchantAsk?.trim(),
			isDraft: data.isDraft,
			isActive: data.isActive
		};
		return this.sanitizePayload(payload);
	}
}
